import { useId } from "react";
import FlashcardsDeckListItem from "@/components/flashcards/FlashcardsDeckListItem";
import { cn } from "@/lib/utils";
import {
  moduleGroupHeading,
  type DeckModuleGroup,
} from "@/services/flashcardsService";

interface FlashcardsDeckModuleGroupProps {
  group: DeckModuleGroup;
  selectedDeckId: string | null;
  onSelectDeck: (deckId: string) => void;
  className?: string;
}

/**
 * Module heading and its collected Lernkarten — used in the picker aside.
 */
const FlashcardsDeckModuleGroup = ({
  group,
  selectedDeckId,
  onSelectDeck,
  className,
}: FlashcardsDeckModuleGroupProps) => {
  const headingId = useId();
  const heading = moduleGroupHeading(group.moduleIndex, group.moduleTitle);

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <h2
        id={headingId}
        className="ps-3 text-h6 font-bold leading-heading text-primary"
      >
        {heading}
      </h2>
      <ul aria-labelledby={headingId} className="flex flex-col gap-2">
        {group.decks.map((deck) => (
          <li key={deck.id}>
            <FlashcardsDeckListItem
              title={deck.deckTitle}
              cardCount={deck.totalCards}
              isSelected={deck.id === selectedDeckId}
              onSelect={() => onSelectDeck(deck.id)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FlashcardsDeckModuleGroup;
